import {CommonModule} from '@angular/common';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FdkButtonComponent, FdkIconComponent, FdkSpinnerComponent} from 'fasten-design-kit';

export type DevToolsResetState = 'idle' | 'loading' | 'success' | 'error';

@Component({
  selector: 'app-dev-tools',
  templateUrl: './dev-tools.component.html',
  styleUrls: ['./dev-tools.component.css'],
  standalone: true,
  imports: [CommonModule, FdkButtonComponent, FdkIconComponent, FdkSpinnerComponent],
})
export class DevToolsComponent {
  @Input() showSkip = false;
  @Input() showResetConnections = false;
  @Input() resetState: DevToolsResetState = 'idle';
  @Input() skipTooltip = 'Continue without completing this step.';
  @Input() resetConnectionsTooltip = 'Remove the test connections associated with this profile.';

  @Output() skip = new EventEmitter<void>();
  @Output() resetConnections = new EventEmitter<void>();

  get resetButtonLabel(): string {
    switch (this.resetState) {
      case 'loading':
        return 'Resetting...';
      case 'success':
        return 'Connections reset';
      case 'error':
        return 'Retry reset';
      default:
        return 'Reset connections';
    }
  }
}
